import React, { useState } from 'react';
import iconClose from '@/assets/images/icon_dialogClose.png'
import styles from './index.less';

const MealDialog = (props) => {
  const { title, list } = props.data

  const foodItem = (item={})=>{
    return <div className={`${styles.dialog_text_group_1} ${styles.flex_col}`}>
      <span className={`${styles.dialog_text_3}`}>{item.name}</span>
      {
        item?.food?.map((foodName:string)=>{
          return <span className={`${styles.dialog_text_4}`}>·&nbsp;{foodName}</span>
        })

      }
    </div>
  }
  return <div className={`${styles.dialog_page} ${styles.flex_col}`}>
  <div className={`${styles.dialog_group_1} ${styles.flex_col}`}>
    <div className={`${styles.dialog_box_1} ${styles.flex_col}`}>
      <div className={`${styles.dialog_group_2} ${styles.flex_col} ${styles.justify_between}`}>
        <span className={`${styles.dialog_text_1}`}>{title}</span>
        <img
          className={`${styles.dialog_icon_1}`}
          src={iconClose}
          onClick={props.onClose}
        />
      </div>
      <div className={`${styles.dialog_group_3} ${styles.flex_col}`}></div>
      <div className={styles.dialog_content}>
        <span className={`${styles.dialog_text_2}`}>{title}</span>
        {
          list?.map(item=>{
            return foodItem(item)
          })
        }
      </div>
    </div>
  </div>
</div>
}
const MealItem = (props) => {
  const {time='', title='', list=[]} = props.data || {}

  const foodItem = (item={})=>{
    return <div className={`${styles.text_group_4} ${styles.flex_col} ${styles.justify_between}`}>
      <span className={`${styles.text_47}`}>{item.name}</span>
      {
        item?.food?.map((foodName:string)=>{
          return <span className={`${styles.text_48}`}>·&nbsp;{foodName}</span>
        })

      }
    </div>
  }
  return <div className={`${styles.group_12} ${styles.flex_col}`}>
    <span className={`${styles.text_33}`}>{title}</span>
    <div className={`${styles.text_group_4} ${styles.flex_col} ${styles.justify_between}`}>
      <span  className={`${styles.text_34}`}>供应时间</span>
      <span  className={`${styles.text_35}`}>{time}</span>
    </div>

    { list?.map((item)=>{
      return foodItem(item)
    })}

    <div className={`${styles.text_wrapper_9} ${styles.flex_col}`} onClick={()=>props.onMenuOpen(props.data)} >
      <span className={`${styles.text_41}`} >查看完整菜单</span>
    </div>
  </div>
}

const MealList = (props) => {
  const [visible, setVisible] = useState(false)
  const [menu, setMenu] = useState({})
  const list = props.list
  const onMenuOpen = (data={}) => {
    setMenu(data)
    setVisible(true)
  }

  return <div className={styles.group_10_boxWrap}>
    {
      list?.map(item=>{
        return <MealItem data={item} onMenuOpen={onMenuOpen}/>
      })
    }
    {visible && <MealDialog data={menu} onClose={()=>setVisible(false)}/>}
  </div>
};

export default MealList;
